import { createBrowserRouter } from 'react-router-dom';
import { RootLayout } from './components/RootLayout';
import { ComingSoon } from './pages/ComingSoon';
import { NotFound } from './pages/NotFound';

// The site is a single coming-soon landing page. The only working route is the
// landing page; every other path renders the 404 page.
export const router = createBrowserRouter([
  {
    element: <RootLayout />,
    children: [
      { index: true, element: <ComingSoon /> },
      { path: '*', element: <NotFound /> },
    ],
  },
]);
